import { Injectable } from '@angular/core';
import { UiDocumentService } from 'e5core-angular-services';
import { Observable } from 'rxjs';
import { IDataSource } from './data-source';
import { DataSourceOptions } from './data-source-options';
import { DataSourceColumn, DataSourceColumnStatus } from './data-source-column';
import { DataSourceQuery } from './data-source-query';
import { DataSourceResults } from './data-source-results';
import { map } from 'rxjs/operators';
import { FieldDefinitionModel } from '../models/field-definition.model';
import { of } from 'rxjs';

@Injectable({
	providedIn: null //'root'
})
export class DocumentDataSourceService implements IDataSource {

  libraryId : number;
	folderName : string = "";
	includeSelect : boolean;
	searchText : string;
  fieldsToShow : FieldDefinitionModel[] = null;
	searchOptions: DataSourceOptions = {} ;

	constructor(private uiDocumentService: UiDocumentService) {
	}

	public defaultOptions(): DataSourceOptions {
		return (this.searchOptions) ;
	}

	public setDefaultOptions(options:DataSourceOptions) {
		this.searchOptions = {...options} ; // clone
	}

	public setLibrary(libraryId : number, folderName : string, includeSelect : boolean, fieldsToShow: FieldDefinitionModel[], searchText: string): DocumentDataSourceService {
    this.libraryId = libraryId;
		this.folderName = folderName;
		this.includeSelect = includeSelect;
		this.fieldsToShow = fieldsToShow;
		this.searchText = searchText;
		return (this)
	}

	columns(): Observable<DataSourceColumn[]> {
		let columns = this.fieldsToShow.filter(f => f.display).map<DataSourceColumn>(sf => <DataSourceColumn>{
			code: sf.fieldCode,
			label: sf.name,
			type: "Input",
			status: DataSourceColumnStatus.Selected
		});
		columns = this.addOptionalColumns(columns);
		return of(columns);
	}

	private addOptionalColumns(columns:DataSourceColumn[]): DataSourceColumn[] {
		if(this.includeSelect)
			// Add to start
			columns.unshift(<DataSourceColumn>{
				label: "",
				code: "ActionSelect",
				type: "ActionSelect",
				status: DataSourceColumnStatus.Selected
			});
		return (columns) ;
	}

	public read(page: number, pageSize: number, optionsIn: DataSourceOptions): Observable<DataSourceResults> {
		let options: DataSourceOptions = {
			...this.searchOptions,
			...optionsIn
		}
		
		var returnFields = "";
    if (this.fieldsToShow && typeof(this.fieldsToShow) !== 'undefined') {
      //var fieldsToRetrieve = fieldsToShow.reduce((fid, fs) => [ ...fid, ...fs.fieldId ], <string[]> []);
      //.join(",")
      var fieldsToRetrieve = this.fieldsToShow.filter(f => f.display).reduce(function(a, b) {return [a,b.fieldId]}, []).toString();
      if (fieldsToRetrieve.length> 0)
        fieldsToRetrieve = fieldsToRetrieve.substring(1);
      returnFields = fieldsToRetrieve;
		}
		var orderBy = (options && options.orderBy) ? options.orderBy : "";
		
		pageSize = (pageSize) ? pageSize : 10

		//return this.uiDocumentService.getAll(this.libraryId, returnFields, page, pageSize, "", this.searchText, orderBy)
		return this.uiDocumentService.getAll(this.libraryId, { 
			returnFields: returnFields, 
			page: page, 
			pageSize:pageSize, 
			orderBy:"", 
			searchBy:this.searchText, 
			filter: "",
			folderName: ""
		})
		.pipe<DataSourceResults>(
			map(results => {
				return {
					total: results.length,
					data: this.mapResults(results)
				}
			})
		);
	}

  private mapResults(result: any): any[] {
    let results: any[] = [];

    if (result && result.length > 0) {
      for (var r: number = 0; r < result.length; r++) {
        let dataRow: any = result[r];
        let objectRow: any = {};
        for (var c: number = 0; c < this.fieldsToShow.length; c++) {
          let field = this.fieldsToShow[c];
          objectRow[field.fieldCode] = dataRow.fields[field.fieldCode];
        }
        results[results.length] = objectRow;
      }
    }
    return results
  }

	// In order to use the foundation service we need to map the DataSourceQuery into 
	//	the underlying foundation query
	// 	{
	// 		"filters": [
	// 	  		{
	// 				"field": "string",
	// 				"operator": "string",
	// 				"value": "string"
	// 	  		}
	// 		],
	// 		"logic": "string"
	// 	}
	private mapQueryToFilterBy(query:DataSourceQuery): any {
		let filterBy = {} ;
		if(query && query.Expressions && query.Expressions.length > 0) {
			let filters = query.Expressions
				.filter( e => e.Value )
				.map( e => {
					return {
						field : e.Field,
						value : e.Value
					}
				}) ;
			filterBy = {
				filters : filters
			}
		}
		return (filterBy)
	}
}
